import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { datadogRum } from '@datadog/browser-rum';

function DatadogViewTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    const pageKey = pathname.includes('event') ? 'killshot' : 'unknown';

    datadogRum.setViewContextProperty('page_key', pageKey);
  }, [pathname]);

  return null;
}

export default DatadogViewTracker;
